import { render, staticRenderFns } from "./AdminCompanySelect.vue?vue&type=template&id=74f815ca&scoped=true&"
import script from "./AdminCompanySelect.vue?vue&type=script&lang=ts&"
export * from "./AdminCompanySelect.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCompanySelect.vue?vue&type=style&index=0&id=74f815ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f815ca",
  null
  
)

export default component.exports